import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as actions from '../../../actions/index';
import * as _actionsJourney from '../../../actions/journey1';
import './Step5.scss';
import { ReactComponent as DatumFix } from '../../../assets/icons/17_datum_fix.svg';
import { ReactComponent as DatumFlexibel } from '../../../assets/icons/18_datum_flexibel.svg';
import { ReactComponent as IconInnovation } from '../../../assets/icons/e_i_innovation.svg';
import { useNavigate } from 'react-router';
import Step3 from '../../Journey2/Step3';
import { Button, EButtonType, BoxInput, IBoxInputAlignment, IBoxInputTypes } from '@repo/apg-ui';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney2: any;
  actionsJourney: typeof _actionsJourney;
  intl: any;
  loading: any;
  locales: any;
  possibleBookingDates: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
}

const Step5 = (props: Props) => {
  const chooseDateTypeRadioOptions = [
    {
      title: props.intl.formatMessage({
        id: 'ec.journey01.step05.chooseDateFixedTitle',
        defaultMessage: 'Fixes Datum wählen',
      }),
      text: props.intl.formatMessage({
        id: 'ec.journey01.step05.chooseDateFixedExplanation',
        defaultMessage: 'Fixes Startdatum wählen',
      }),
      icon: <DatumFix />,
      value: '0',
    },
    {
      title: props.intl.formatMessage({
        id: 'ec.journey01.step05.chooseDateFlexibleTitle',
        defaultMessage: 'Flexibles Datum wählen',
      }),
      text: props.intl.formatMessage({
        id: 'ec.journey01.step05.chooseDateFlexibleExplanation',
        defaultMessage: 'Startdatum wählen +/- 7 Tage',
      }),
      icon: <DatumFlexibel />,
      value: '1',
    },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    const { userDataEC } = props;

    if (userDataEC.industry === null) {
      navigate({ pathname: '/journey1/4' });
    }
  });

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
  //     const {
  //         actionsJourney: { updateDateAccuracy, updateStartDate },
  //         possibleBookingDates,
  //     } = this.props;
  //     const { dateAccuracy, dateRange } = this.state;
  //
  //     if (prevProps.possibleBookingDates != possibleBookingDates) {
  //         if (possibleBookingDates && possibleBookingDates.start) {
  //             this.handleDateChange(new Date(possibleBookingDates.start.date));
  //         }
  //     }
  //
  //     if (prevState.dateAccuracy !== dateAccuracy) {
  //         updateDateAccuracy(dateAccuracy);
  //     }
  //
  //     if (prevState.dateRange !== dateRange) {
  //         updateStartDate([dateRange[0].startDate, this.props.userDataEC.duration]);
  //     }
  // }

  const next = () => {
    const {
      actionsJourney: { possibleFormats },
      userDataEC: { locations, budget },
    } = props;
    let payload = {};

    payload['coordinates'] = Object.keys(locations).map((locationKey) => {
      const location = locations[locationKey];

      return {
        coordinates: [
          {
            longitude: location.lngLtd.lng,
            latitude: location.lngLtd.lat,
            mode: location.types.includes('locality') ? 0 : 1,
            radius: location.circle.radius,
            name: location.address,
          },
        ],
        budget,
      };
    });

    possibleFormats(payload).then((res) => {
      if (res && res.data && res.data.digital === 0) {
        navigate({ pathname: '/journey1/7' });
      } else {
        navigate({ pathname: '/journey1/6' });
      }
    });
  };

  return (
    <div>
      <div>
        <h4 className='title-journey'>
          <FormattedMessage id='ec.journey01.step05.header' defaultMessage='In welchem Zeitraum möchten Sie werben?' />
        </h4>

        <div className='d-flex'>
          <IconInnovation />
          <p className='text-left align-self-center ms-4 me-48 w-100 sub-title'>
            <FormattedMessage
              id='ec.journey01.step05.noticeStartOnMonday'
              defaultMessage='Aushangbeginn jeweils ab Montag'
            />
          </p>
        </div>
      </div>
      <BoxInput
        id='date-input'
        options={chooseDateTypeRadioOptions}
        selected={props.userDataEC.dateAccuracy}
        type={IBoxInputTypes.Radio}
        alignment={IBoxInputAlignment.FullWidth}
        onChange={(value: any) => props.actionsJourney.updateDateAccuracy(value)}
      />
      <div className='mt-4'>
        <Step3 isSkipBottomNavigation={true} />
      </div>
      <div className='d-flex twoButtons mt-5'>
        <Button onClick={() => navigate({ pathname: '/journey1/4' })} buttonType={EButtonType.InvertedPillMedium}>
          <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
        </Button>

        <Button
          isDisabled={!props.userDataEC.startDate || !props.userDataEC.dateAccuracy}
          onClick={next}
          buttonType={EButtonType.PillMedium}
          className='ms-4'
        >
          <FormattedMessage id='ec.components.buttons.next' defaultMessage='Weiter' />
        </Button>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step5)));
